import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import PositivacaoMobile from "./PositivacaoMobile";
import PositivacaoDesktop from "./PositivacaoDesktop";

function Positivacao({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <PositivacaoMobile app={app} config={config} />
  ) : (
    <PositivacaoDesktop app={app} config={config} />
  );
}

Positivacao.defaultProps = {
  app: null,
  config: {},
};

Positivacao.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Positivacao;
